//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as fudouActiveApi from '@/api/fudouActiveApi.js';
import * as suplierCouponsApi from '@/api/suplierCouponsApi.js';
import throttle from '@/utils/throttle';
export default {
  components: {},
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      supplierOption: [],
      TYPE_OPTIONS: [{
        value: -2,
        label: '已取消'
      }, {
        value: -1,
        label: '待支付'
      }, {
        value: 1,
        label: '进行中'
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.handlerGetListData(this.listPram);
    this.searchSupplier('');
  },
  methods: {
    throttle: throttle,
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      if (!this.listPram.supplierId) {
        this.searchSupplier('');
      }
      ;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      fudouActiveApi.ListArticle(pram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    searchSupplier: function searchSupplier() {
      var _this2 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.supplierOption = [];
      suplierCouponsApi.getAllSupplier(keyword).then(function (res) {
        _this2.supplierOption = res || [];
      });
    },
    handleSupplierSearch: function handleSupplierSearch(data) {
      var _this3 = this;
      this.throttle(function () {
        _this3.searchSupplier(data);
      }, 300)();
    }
  }
};